export const createurl = (name) =>
    {
        return name
            .toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-")
            .replace(/-+/g, "-").trim();
    };